import moment from "moment";
import { Calendar } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Meeting } from "@platform/types/platform.types";
import createGoogleCalendarUrl from "../utils/createGoogleCalendarUrl";

export type Props = {
  onClick?: () => void;
  meeting: Meeting;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
  onAddCalendarEvent: (
    meetingId: number,
    calendarType: "google" | "ical"
  ) => void;
};

export function AddToGoogleCalendarButton({
  meeting,
  onClick,
  eventTitle,
  eventDescription,
  eventUrl,
  onAddCalendarEvent,
}: Props) {
  const handleClick = () => {
    const calendarUrl = createGoogleCalendarUrl({
      startDateTime: moment.utc(meeting.start_time).toISOString(),
      endDateTime: moment.utc(meeting.end_time).toISOString(),
      eventTitle: eventTitle,
      eventDescription: eventDescription,
      eventUrl: eventUrl,
    });

    onAddCalendarEvent(meeting.id, "google");

    onClick?.();

    window.open(calendarUrl, "_blank");
  };

  return (
    <Button
      variant="secondary"
      size="sm"
      iconComponent={Calendar}
      onClick={handleClick}
    >
      Add to Google Cal
    </Button>
  );
}

export default AddToGoogleCalendarButton;
